/**
* ProfileServices
*/

class ProfileServices{
    constructor() {
        this.set();
    }

    set(profileId) {
        if(profileId) {
            this.isLogged = true;
            this.profileId = profileId;
        }
        else {
            this.isLogged = false;
            this.profileId = 0;
        }
    }

    requestLogin() {
        if(!this.isLogged) {
            evedo.openLogin();
        }
    }

    requestRegistration() {
        if(!this.isLogged) {
            evedo.openRegistration();
        }
    }

    changeLanguage(callback) {
        if(window.activeModalInstance) {
            return;
        }

        if(!this.changeLanguageModal) {
            this.changeLanguageModal = new ModalTemplate().create('change-language-modal', { keyboard: false });
        }

        window.activeModalInstance = new ChangeLanguageModal(this.changeLanguageModal, callback);
    }

    // CATEGORIES:

    // setCategory(id, status, callback) {
    //     if(!this.isLogged) {
    //         return;
    //     }
    // },

    setCategories(ids, callback) {
        if(!this.isLogged) {
            return;
        }

        new DataSender({
            data: { ids: ids },
            url: '/profile/set-categories/',

            success: function(data) {
                if(callback) {
                    callback(data);
                }
            }
        });
    }

    // EVENTS:

    acceptCopromoteInvite(inviteId, callback) {
        if(!this.isLogged) {
            return;
        }

        new DataSender({
            data: { id: inviteId },
            url: '/event/accept-cohost-invite/',

            success: function(data) {
                if(data) {
                    if(callback) {
                        callback(data);
                    }
                }
            }
        });
    }

    // acceptCopromoteRequest(requestId, callback) {
    //     if(!this.isLogged) {
    //         return;
    //     }
    // },

    declineCopromoteInvite(inviteId, callback) {
        if(!this.isLogged) {
            return;
        }

        new DataSender({
            data: { id: inviteId },
            url: '/event/decline-cohost-invite/',

            success: function(data) {
                if(data) {
                    if(callback) {
                        callback(data);
                    }
                }
            }
        });
    }

    // declineCopromoteRequest(requestId, callback) {
    //     if(!this.isLogged) {
    //         return;
    //     }
    // },

    buyTickets(eventId, callback, options) {
        if (window.evedo != undefined && window.evedo.mobileDevice()) {
            window.open('/event/tickets/mobile/?id=' + eventId, '_blank');
        }
        else {
            if(window.activeModalInstance) {
                return;
            }

            if(!this.buyTicketsModal) {
                this.buyTicketsModal = new ModalTemplate().create('buy-tickets-modal', { keyboard: false });
            }

            window.activeModalInstance = new BuyTicketsModal(this.buyTicketsModal, eventId, callback, options);
        }
    }

    embedTickets(eventId) {
        if(window.activeModalInstance || !this.isLogged) {
            return;
        }

        if(!this.embedTicketsModal) {
            this.embedTicketsModal = new ModalTemplate().create('embed-tickets-modal', { keyboard: false });
        }

        window.activeModalInstance = new EmbedTicketsModal(this.embedTicketsModal, eventId);
    }

    manageDiscountCodes(eventId) {
        if(window.activeModalInstance) {
            return;
        }

        if(!this.discountCodesModal) {
            this.discountCodesModal = new ModalTemplate().create('manage-discount-codes-modal', { keyboard: false });
        }

        window.activeModalInstance = new ManageDiscountCodesModal(this.discountCodesModal, eventId);
    }

    openBillingInformation(eventId, callback) {
        if(window.activeModalInstance || !this.isLogged) {
            return;
        }

        if(!this.billingInformationModal) {
            this.billingInformationModal = new ModalTemplate().create('billing-information-modal', { keyboard: false });
        }

        window.activeModalInstance = new BillingInformationModal(this.billingInformationModal, eventId, callback);
    }

    importEvent() {
        if(!this.isLogged) {
            return;
        }

        var that = this;

        if(!this.importEventModal) {
            this.importEventModal = new ModalTemplate().create('import-event-modal');

            new DataLoader({
                url: '/event/import/load/',

                success: function(data) {
                    if(data.html) {
                        window.importEventModalInstance = new ImportEventModal(that.importEventModal, data.html);
                        window.importEventModalInstance.reset();
                        that.importEventModal.show();
                    }
                }
            });
        }
        else {
            window.importEventModalInstance.reset();
            this.importEventModal.show();
        }
    }

    rsvp(eventId, status, highlight, callback) {
        if(!this.isLogged) {
            this.requestLogin();
            return;
        }

        new DataSender({
            data: {
                id: eventId,
                status: status
            },
            url: '/event/change-rsvp/',

            success: function(data) {
                if(data.success) {
                    if(callback) {
                        callback(data);
                    }

                    if(status == 1) {
                        new DataSender({
                            data: { id: eventId },
                            url: '/event/change-rsvp-facebook/'
                        });

                        new DataSender({
                            data: { id: eventId },
                            url: '/event/change-rsvp-twitter/'
                        });
                    }

                    if(highlight) {
                        window.evedo.highlightRsvp(status);
                    }
                }
            }
        });
    }

    // FEATURE EVENT/PROMOTER:

    feature(type, id, callback) {
        if(window.activeModalInstance || !this.isLogged) {
            return;
        }

        if(!this.featureModal) {
            this.featureModal = new ModalTemplate().create('feature-modal', { keyboard: false });
        }

        window.activeModalInstance = new FeatureModal(this.featureModal, (type == 'promoter') ? 'promoter' : 'event', id, callback);
    }

    featureEvent(id, callback) {
        this.feature('event', id, callback);
    }

    featurePromoter(id, callback) {
        this.feature('promoter', id, callback);
    }

    featuredReport(type, id) {
        if(window.activeModalInstance || !this.isLogged) {
            return;
        }

        if(!this.featuredReportModal) {
            this.featuredReportModal = new ModalTemplate().create('featured-report-modal', { keyboard: false });
        }

        window.activeModalInstance = new FeaturedCampaignsReportModal(this.featuredReportModal, (type == 'promoter') ? 'promoter' : 'event', id);
    }

    featuredEventReport(id) {
        this.featuredReport('event', id);
    }

    featuredPromoterReport(id) {
        this.featuredReport('promoter', id);
    }

    // FRIENDS:

    // friend(id, callback) {
    //     if(!this.isLogged) {
    //         this.requestLogin();
    //         return;
    //     }
    // }å

    friendMultiple(ids, callback) {
        if(!this.isLogged) {
            return;
        }

        new DataSender({
            data: { ids: ids },
            url: '/profile/friend-multiple/',

            success: function(data) {
                if(callback) {
                    callback(data);
                }
            }
        });
    }

    // unfriend(id, callback) {
    //     if(!this.isLogged) {
    //         return;
    //     }
    // },

    // LOCATION:

    setLocation(cityId, callback) {
        if(!this.isLogged) {
            return;
        }

        new DataSender({
            data: { id: cityId },
            url: '/profile/set-location/',

            success: function(data) {
                if(callback) {
                    callback(data);
                }
            }
        });
    }

    // PROMOTERS:

    follow(promoterId, callback) {
        if(!this.isLogged) {
            this.requestLogin();
            return;
        }

        new DataSender({
            data: { id: promoterId },
            url: '/promoter-following-follow/',

            success: function(data) {
                if(data) {
                    if(callback) {
                        callback(data);
                    }

                    new DataSender({
                        data: { id: promoterId },
                        url: '/promoter/follow-facebook/'
                    });

                    new DataSender({
                        data: { id: promoterId },
                        url: '/promoter/follow-twitter/'
                    });
                }
            }
        });
    }

    unfollow(promoterId, callback) {
        if(!this.isLogged) {
            this.requestLogin();
            return;
        }

        new DataSender({
            data: { id: promoterId },
            url: '/promoter-following-unfollow/',

            success: function(data) {
                if(data) {
                    if(callback) {
                        callback(data);
                    }
                }
            }
        });
    }

    // SHARE EVENT/PROMTOER:

    share(type, id, callback) {
        if(window.activeModalInstance) {
            return;
        }

        if(!this.isLogged) {
            this.requestLogin();
            return;
        }

        var that = this;
        type = (type == 'event') ? 'event' : 'promoter';

        if(!this.shareModal) {
            this.shareModal = new ModalTemplate().create('share-modal');

            this.shareModal.on('show', function() {
                window.activeModalInstance = true;
            });

            this.shareModal.on('hide', function() {
                window.activeModalInstance = null;
            });
        }

        this.shareModal.html('<div class="loader"><i class="fas fa-circle-notch fa-spin"></i></div>');
        this.shareModal.show();

        new DataSender({
            data: { id: id },
            url: '/' + type + '/share/load/',

            success: function(data) {
                if(data.status) {
                    window.activeModalInstance = new ShareModal(that.shareModal, {
                        type: type,
                        id: id,
                        html: data.html,
                        moreFriends: data.more,
                        callback: (callback) ? callback : null
                    });
                }
            },

            error: function() {
                that.shareModal.hide();
            }
        });
    }

    shareEvent(id, callback) {
        this.share('event', id, callback);
    }

    sharePromoter(id, callback) {
        this.share('promoter', id, callback);
    }

    // TAGS:

    // setTag(id, status, callback) {
    //     if(!this.isLogged) {
    //         return;
    //     }
    // }

    setTags(tags, status, callback) {
        if(!this.isLogged) {
            return;
        }

        if(tags.length) {
            new DataSender({
                data: { ids: tags, status: status },
                url: '/profile/set-tags/',

                success: function(data) {
                    if(callback) {
                        callback(data);
                    }
                }
            });
        }
    }
}

export { ProfileServices }
